<template>

	<!-- Information Card 2 -->
	<a-card :bordered="false" class="card-info-2 h-full">
		<div class="col-content h-full" style="background-image: url('images/info-card-2.jpg')">
			<div class="card-content">
				<h5>Hey Rene!</h5>
				<p><b>Tip of the day</b> - You can save your recipe as a template.</p>
				<p>- Once you save it you can use it to jump start the next one.</p>
			</div>
			<div class="card-footer">
				<a-button ghost  shape="round">
					<span>Read all tips</span>
    				<a-icon class="ml-5" type="arrow-right" />
				</a-button>
			</div>
		</div>
	</a-card>
	<!-- / Information Card 2 -->

</template>

<script>

	export default ({
		data() {
			return {
			}
		},
	})

</script>